module.exports = __webpack_public_path__ + "static/img/UOOYAA_07_02.3cac9fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue11/01/UOOYAA_07_02.jpg
// module id = o6y9
// module chunks = 7